import { useIntl } from "react-intl";
import type { Clave } from "./i18n";

// Un único punto de acceso a los textos: la clave está tipada, un texto en duro no compila.
export function useT() {
  const intl = useIntl();
  return (clave: Clave, valores?: Record<string, string | number>) =>
    intl.formatMessage({ id: clave }, valores);
}
